/**
 * Spec 327: fired by the API client when the server answers
 * 403 TOS_ACCEPTANCE_REQUIRED, so ToSReacceptanceModal re-checks the user's
 * status and opens without waiting for its next refetch.
 */
export const TOS_REQUIRED_EVENT = 'tos:acceptance-required';
